import { render, staticRenderFns } from "./customer-detail.vue?vue&type=template&id=6a2fe7ee&"
import script from "./customer-detail.vue.ts?vue&type=script&lang=ts&"
export * from "./customer-detail.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports